<template>
  <UiAlertDialog :open="props.open">
    <UiAlertDialogContent>
      <UiAlertDialogHeader>
        <TheDialogHeader :title="props.title" @click="$emit('dialog:close')" />
        <UiAlertDialogDescription>
          <div class="p-4 pt-6 pb-0 text-regular-18">
            {{ props.text }}
          </div>
        </UiAlertDialogDescription>
      </UiAlertDialogHeader>
      <UiAlertDialogFooter class="px-4 pb-4">
        <UiButton
          tabindex="-1"
          class="border bg-inherit border-iq-white text-regular-16 hover:border-iq-red"
          @click="emit('dialog:close')"
          >{{ props.textCancel }}</UiButton
        >
        <UiButton
          class="text-regular-16 bg-iq-red/90 hover:bg-iq-red/80"
          @click="emit('dialog:confirm')"
          >{{ props.textConfirm }}</UiButton
        >
      </UiAlertDialogFooter>
    </UiAlertDialogContent>
  </UiAlertDialog>
</template>

<script setup lang="ts">
const emit = defineEmits<{
  'dialog:confirm': [];
  'dialog:close': [];
}>();

const props = defineProps<{
  open: boolean;
  text: string;
  textConfirm: string;
  textCancel: string;
  title: string;
}>();
</script>
